import { createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
    // Get Wallet Balance
    getBalanceLoading: false,
    getBalanceSuccess: false,
    getBalanceFail: false,
    getBalanceData: null,
    getBalanceErrorMessage: null,

    // Get Credit Transactions
    getCreditTransactionsLoading: false,
    getCreditTransactionsSuccess: false,
    getCreditTransactionsFail: false,
    getCreditTransactionsData: null,
    getCreditTransactionsErrorMessage: null,

    // Get Treasure Point Transactions
    getTreasureTransactionsLoading: false,
    getTreasureTransactionsSuccess: false,
    getTreasureTransactionsFail: false,
    getTreasureTransactionsData: null,
    getTreasureTransactionsErrorMessage: null,

    // Get VIP Point Transactions
    getVipTransactionsLoading: false,
    getVipTransactionsSuccess: false,
    getVipTransactionsFail: false,
    getVipTransactionsData: null,
    getVipTransactionsErrorMessage: null,

    // Get AirTag Point Transactions
    getAirtagTransactionsLoading: false,
    getAirtagTransactionsSuccess: false,
    getAirtagTransactionsFail: false,
    getAirtagTransactionsData: null,
    getAirtagTransactionsErrorMessage: null,
}

export const walletTransactionsSlice = createSlice({
    name: "walletTransactions",
    initialState,
    reducers: {
        // Get Balance Actions
        getBalanceRequest: (state) => {
            state.getBalanceLoading = true
            state.getBalanceSuccess = false
            state.getBalanceFail = false
            state.getBalanceErrorMessage = null
        },
        getBalanceSuccessAction: (state, action) => {
            state.getBalanceLoading = false
            state.getBalanceSuccess = true
            state.getBalanceFail = false
            state.getBalanceData = action.payload
            state.getBalanceErrorMessage = null
        },
        getBalanceFailAction: (state, action) => {
            state.getBalanceLoading = false
            state.getBalanceSuccess = false
            state.getBalanceFail = true
            state.getBalanceErrorMessage = action.payload
        },
        resetGetBalance: (state) => {
            state.getBalanceLoading = false
            state.getBalanceSuccess = false
            state.getBalanceFail = false
            state.getBalanceData = null
            state.getBalanceErrorMessage = null
        },

        // Get Credit Transactions Actions
        getCreditTransactionsRequest: (state) => {
            state.getCreditTransactionsLoading = true
            state.getCreditTransactionsSuccess = false
            state.getCreditTransactionsFail = false
            state.getCreditTransactionsErrorMessage = null
        },
        getCreditTransactionsSuccessAction: (state, action) => {
            state.getCreditTransactionsLoading = false
            state.getCreditTransactionsSuccess = true
            state.getCreditTransactionsFail = false
            state.getCreditTransactionsData = action.payload
            state.getCreditTransactionsErrorMessage = null
        },
        getCreditTransactionsFailAction: (state, action) => {
            state.getCreditTransactionsLoading = false
            state.getCreditTransactionsSuccess = false
            state.getCreditTransactionsFail = true
            state.getCreditTransactionsErrorMessage = action.payload
        },
        resetGetCreditTransactions: (state) => {
            state.getCreditTransactionsLoading = false
            state.getCreditTransactionsSuccess = false
            state.getCreditTransactionsFail = false
            state.getCreditTransactionsData = null
            state.getCreditTransactionsErrorMessage = null
        },

        // Get Treasure Transactions Actions
        getTreasureTransactionsRequest: (state) => {
            state.getTreasureTransactionsLoading = true
            state.getTreasureTransactionsSuccess = false
            state.getTreasureTransactionsFail = false
            state.getTreasureTransactionsErrorMessage = null
        },
        getTreasureTransactionsSuccessAction: (state, action) => {
            state.getTreasureTransactionsLoading = false
            state.getTreasureTransactionsSuccess = true
            state.getTreasureTransactionsFail = false
            state.getTreasureTransactionsData = action.payload
            state.getTreasureTransactionsErrorMessage = null
        },
        getTreasureTransactionsFailAction: (state, action) => {
            state.getTreasureTransactionsLoading = false
            state.getTreasureTransactionsSuccess = false
            state.getTreasureTransactionsFail = true
            state.getTreasureTransactionsErrorMessage = action.payload
        },
        resetGetTreasureTransactions: (state) => {
            state.getTreasureTransactionsLoading = false
            state.getTreasureTransactionsSuccess = false
            state.getTreasureTransactionsFail = false
            state.getTreasureTransactionsData = null
            state.getTreasureTransactionsErrorMessage = null
        },

        // Get VIP Transactions Actions
        getVipTransactionsRequest: (state) => {
            state.getVipTransactionsLoading = true
            state.getVipTransactionsSuccess = false
            state.getVipTransactionsFail = false
            state.getVipTransactionsErrorMessage = null
        },
        getVipTransactionsSuccessAction: (state, action) => {
            state.getVipTransactionsLoading = false
            state.getVipTransactionsSuccess = true
            state.getVipTransactionsFail = false
            state.getVipTransactionsData = action.payload
            state.getVipTransactionsErrorMessage = null
        },
        getVipTransactionsFailAction: (state, action) => {
            state.getVipTransactionsLoading = false
            state.getVipTransactionsSuccess = false
            state.getVipTransactionsFail = true
            state.getVipTransactionsErrorMessage = action.payload
        },
        resetGetVipTransactions: (state) => {
            state.getVipTransactionsLoading = false
            state.getVipTransactionsSuccess = false
            state.getVipTransactionsFail = false
            state.getVipTransactionsData = null
            state.getVipTransactionsErrorMessage = null
        },

        // Get AirTag Transactions Actions
        getAirtagTransactionsRequest: (state) => {
            state.getAirtagTransactionsLoading = true
            state.getAirtagTransactionsSuccess = false
            state.getAirtagTransactionsFail = false
            state.getAirtagTransactionsErrorMessage = null
        },
        getAirtagTransactionsSuccessAction: (state, action) => {
            state.getAirtagTransactionsLoading = false
            state.getAirtagTransactionsSuccess = true
            state.getAirtagTransactionsFail = false
            state.getAirtagTransactionsData = action.payload
            state.getAirtagTransactionsErrorMessage = null
        },
        getAirtagTransactionsFailAction: (state, action) => {
            state.getAirtagTransactionsLoading = false
            state.getAirtagTransactionsSuccess = false
            state.getAirtagTransactionsFail = true
            state.getAirtagTransactionsErrorMessage = action.payload
        },
        resetGetAirtagTransactions: (state) => {
            state.getAirtagTransactionsLoading = false
            state.getAirtagTransactionsSuccess = false
            state.getAirtagTransactionsFail = false
            state.getAirtagTransactionsData = null
            state.getAirtagTransactionsErrorMessage = null
        },
    },
})

// Action creators
export const {
    getBalanceRequest,
    getBalanceSuccessAction,
    getBalanceFailAction,
    resetGetBalance,
    getCreditTransactionsRequest,
    getCreditTransactionsSuccessAction,
    getCreditTransactionsFailAction,
    resetGetCreditTransactions,
    getTreasureTransactionsRequest,
    getTreasureTransactionsSuccessAction,
    getTreasureTransactionsFailAction,
    resetGetTreasureTransactions,
    getVipTransactionsRequest,
    getVipTransactionsSuccessAction,
    getVipTransactionsFailAction,
    resetGetVipTransactions,
    getAirtagTransactionsRequest,
    getAirtagTransactionsSuccessAction,
    getAirtagTransactionsFailAction,
    resetGetAirtagTransactions,
} = walletTransactionsSlice.actions

// Selectors
export const getBalanceLoading = (state) => state.walletTransactions.getBalanceLoading
export const getBalanceSuccess = (state) => state.walletTransactions.getBalanceSuccess
export const getBalanceFail = (state) => state.walletTransactions.getBalanceFail
export const getBalanceData = (state) => state.walletTransactions.getBalanceData
export const getBalanceErrorMessage = (state) => state.walletTransactions.getBalanceErrorMessage

export const getCreditTransactionsLoading = (state) => state.walletTransactions.getCreditTransactionsLoading
export const getCreditTransactionsSuccess = (state) => state.walletTransactions.getCreditTransactionsSuccess
export const getCreditTransactionsFail = (state) => state.walletTransactions.getCreditTransactionsFail
export const getCreditTransactionsData = (state) => state.walletTransactions.getCreditTransactionsData
export const getCreditTransactionsErrorMessage = (state) => state.walletTransactions.getCreditTransactionsErrorMessage

export const getTreasureTransactionsLoading = (state) => state.walletTransactions.getTreasureTransactionsLoading
export const getTreasureTransactionsSuccess = (state) => state.walletTransactions.getTreasureTransactionsSuccess
export const getTreasureTransactionsFail = (state) => state.walletTransactions.getTreasureTransactionsFail
export const getTreasureTransactionsData = (state) => state.walletTransactions.getTreasureTransactionsData
export const getTreasureTransactionsErrorMessage = (state) => state.walletTransactions.getTreasureTransactionsErrorMessage

export const getVipTransactionsLoading = (state) => state.walletTransactions.getVipTransactionsLoading
export const getVipTransactionsSuccess = (state) => state.walletTransactions.getVipTransactionsSuccess
export const getVipTransactionsFail = (state) => state.walletTransactions.getVipTransactionsFail
export const getVipTransactionsData = (state) => state.walletTransactions.getVipTransactionsData
export const getVipTransactionsErrorMessage = (state) => state.walletTransactions.getVipTransactionsErrorMessage

export const getAirtagTransactionsLoading = (state) => state.walletTransactions.getAirtagTransactionsLoading
export const getAirtagTransactionsSuccess = (state) => state.walletTransactions.getAirtagTransactionsSuccess
export const getAirtagTransactionsFail = (state) => state.walletTransactions.getAirtagTransactionsFail
export const getAirtagTransactionsData = (state) => state.walletTransactions.getAirtagTransactionsData
export const getAirtagTransactionsErrorMessage = (state) => state.walletTransactions.getAirtagTransactionsErrorMessage

// Thunks (API calls)

/**
 * Get wallet balance
 */
export const doGetBalance = () => {
    return async (dispatch) => {
        dispatch(getBalanceRequest())

        try {
            const response = await axios.get(`/api/customer/wallet/balance`)
            dispatch(getBalanceSuccessAction(response.data.data))
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Network error occurred"
            dispatch(getBalanceFailAction(errorMessage))
        }
    }
}

/**
 * Get credit transactions
 * @param {object} params - Query parameters (page, size, transaction_type, start_date, end_date)
 */
export const doGetCreditTransactions = (params = {}) => {
    return async (dispatch) => {
        dispatch(getCreditTransactionsRequest())

        try {
            const queryParams = new URLSearchParams({
                transaction_category: 'wallet_credit',
                ...params,
            }).toString()

            const response = await axios.get(`/api/customer/wallet/transactions?${queryParams}`)
            dispatch(getCreditTransactionsSuccessAction(response.data))
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Network error occurred"
            dispatch(getCreditTransactionsFailAction(errorMessage))
        }
    }
}

/**
 * Get treasure point transactions
 * @param {object} params - Query parameters (page, size, transaction_type, start_date, end_date)
 */
export const doGetTreasureTransactions = (params = {}) => {
    return async (dispatch) => {
        dispatch(getTreasureTransactionsRequest())

        try {
            const queryParams = new URLSearchParams({
                transaction_category: 'point',
                point_type: 'treasure',
                ...params,
            }).toString()

            const response = await axios.get(`/api/customer/wallet/transactions?${queryParams}`)
            dispatch(getTreasureTransactionsSuccessAction(response.data))
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Network error occurred"
            dispatch(getTreasureTransactionsFailAction(errorMessage))
        }
    }
}

/**
 * Get VIP point transactions
 * @param {object} params - Query parameters (page, size, transaction_type, start_date, end_date)
 */
export const doGetVipTransactions = (params = {}) => {
    return async (dispatch) => {
        dispatch(getVipTransactionsRequest())

        try {
            const queryParams = new URLSearchParams({
                transaction_category: 'point',
                point_type: 'vip',
                ...params,
            }).toString()

            const response = await axios.get(`/api/customer/wallet/transactions?${queryParams}`)
            dispatch(getVipTransactionsSuccessAction(response.data))
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Network error occurred"
            dispatch(getVipTransactionsFailAction(errorMessage))
        }
    }
}

/**
 * Get AirTag point transactions
 * @param {object} params - Query parameters (page, size, transaction_type, start_date, end_date)
 */
export const doGetAirtagTransactions = (params = {}) => {
    return async (dispatch) => {
        dispatch(getAirtagTransactionsRequest())

        try {
            const queryParams = new URLSearchParams({
                transaction_category: 'point',
                point_type: 'airtag',
                ...params,
            }).toString()

            const response = await axios.get(`/api/customer/wallet/transactions?${queryParams}`)
            dispatch(getAirtagTransactionsSuccessAction(response.data))
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Network error occurred"
            dispatch(getAirtagTransactionsFailAction(errorMessage))
        }
    }
}

export default walletTransactionsSlice.reducer
